function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Scooter"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.4 92.1h106.2v28.3H28.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.5 177.2h63.8V145L241 114.2V85h-26.9l-8.5-9.3V42.5h-56.7v28.3h28.3v120.5h-42.7v-56.7H56.7C25.4 134.6 0 160 0 191.3v28.3h28.3c0 21.3 14.2 35.4 35.4 35.4s35.4-14.2 35.4-35.4h106.3v-42.4zm-99.3 14.1H28.4c0-15.6 12.7-28.3 28.3-28.3h49.5v28.3zm128.1-42.5h-28.8v-31.2l28.8 31.2z"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(.9999 -.01025 .01025 .9999 -2.239 2.554)",
  cx: "248",
  cy: "219.7",
  r: "35.4"
}))));